export default __webpack_public_path__ + "static/media/images1.4b8ddee0.png";